// Optional browser observations, not a judgement of candidate conduct or complete monitoring.
export const antiCheating = {
  data() { return { leaveAssessmentWindowCount: 0, hasExitedFullScreen: false, fullScreenObserved: false } },
  computed: {
    antiCheatData() {
      return { leaveAssessmentWindowCount: this.leaveAssessmentWindowCount, hasExitedFullScreen: this.hasExitedFullScreen }
    }
  },
  mounted() { document.addEventListener('fullscreenchange', this.onFullscreenChange) },
  beforeDestroy() { document.removeEventListener('fullscreenchange', this.onFullscreenChange) },
  methods: {
    onFullscreenChange() {
      if (!this.assessmentStarted || this.assessmentCompleted) { return }
      if (document.fullscreenElement) { this.fullScreenObserved = true } else if (this.fullScreenObserved) { this.hasExitedFullScreen = true }
    },
    mouseLeaveAssessmentsWindow() {
      if (this.assessmentStarted && !this.assessmentCompleted) { this.leaveAssessmentWindowCount++ }
    },
    async requestFullScreenAssessment() {
      const container = document.documentElement
      if (!container || !container.requestFullscreen) { return }
      try { await container.requestFullscreen(); this.fullScreenObserved = true } catch (_) {
        // Full-screen mode is optional and unsupported/denied requests cannot block an assessment.
      }
    }
  }
}
